import { render } from "./HomePart4.vue?vue&type=template&id=12985206&scoped=true&ts=true"
import script from "./HomePart4.vue?vue&type=script&lang=ts"
export * from "./HomePart4.vue?vue&type=script&lang=ts"

import "./HomePart4.vue?vue&type=style&index=0&id=12985206&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12985206"]])

export default __exports__